import { ViewModel } from 'view_models/view_model'
import { MaterialVersion } from 'entities/material_version'
import { PROBE_COLORS } from 'entities/pcr_run'

export class MaterialVersionViewModel extends ViewModel<MaterialVersion> {
    public numberView = (onClick?: () => void) => {
        return (
            <div
                style={{
                    padding: '2px 5px',
                    borderRadius: 3,
                    fontSize: 11,
                    color: 'white',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    backgroundColor: `${PROBE_COLORS[(this.object.number?.charCodeAt(0) || 0) % PROBE_COLORS.length]}`,
                }}
                onClick={onClick}
            >
                v.{this.object.number}
            </div>
        )
    }
}
